import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_view = _resolveComponent("router-view");

  var _component_el_alert = _resolveComponent("el-alert");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _ctx.showUpdateBanner ? (_openBlock(), _createBlock(_component_el_alert, {
    key: 0,
    onClick: _ctx.openMessageBox,
    ref: "alert",
    id: "el-alert-app",
    title: _ctx.$t('app-update.update-text'),
    center: "",
    type: "success",
    onClose: _ctx.openMessageBox,
    "close-text": " "
  }, null, 8, ["onClick", "title", "onClose"])) : _createCommentVNode("", true)], 64);
}